module.exports = __webpack_public_path__ + "img/1461775005.b251dbdb.jpg";